import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import {
  CleanIcon,
  TrashIcon,
  EditIcon,
  AddIcon,
  LawyerMembershipIcon,
  UserMembershipIcon,
} from 'assets/icons';
import { MembershipService } from 'services';
import ModalCreate from './modal-create';
import AdminPackages from './packages';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  level_id: '',
};

const TABS = {
  MEMBERSHIPS: 1,
  PACKAGES: 2,
};

class AdminMemberships extends React.Component<Props> {
  timer: any = undefined;

  state = {
    form: INITIAL_STATE,
    data: [],
    levels: [],
    colors: [],
    visible: false,
    item: null,
    tab: TABS.MEMBERSHIPS,
  };

  setTab = (tab: number) => {
    this.setState({ tab });
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Membresías',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.loadColors();
    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await MembershipService.admin.get({
      withoutLoading,
      ...this.state.form,
    });
    this.setState({
      data: res.memberships,
    });
  };

  loadColors = async () => {
    const res: any = await MembershipService.admin.getColors({
      withoutLoading: true,
    });
    this.setState({
      levels: res.levels || [],
      colors: res.colors || [],
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
      },
      () => this.load(true),
    );
  };

  edit = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  add = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState(
      {
        visible: false,
        item: null,
      },
      () => this.load(true),
    );
  };

  delete = (e: any, item: any) => {
    e.preventDefault();
    Globals.confirm('¿Desea eliminar la membresía?', async () => {
      await MembershipService.admin.delete({
        membership_id: item.id,
      });
      this.load(true);
    });
  };

  render() {
    const { visible, tab } = this.state;

    return (
      <div id='admin-memberships'>
        <div className='row row-tabs'>
          <div className='col-md-6 text-center'>
            <button
              className={`btn btn-tab ${tab == TABS.MEMBERSHIPS ? 'active' : ''}`}
              onClick={() => this.setTab(TABS.MEMBERSHIPS)}
            >
              <p>Membresías</p>
            </button>
          </div>
          <div className='col-md-6 text-center'>
            <button
              className={`btn btn-tab ${tab == TABS.PACKAGES ? 'active' : ''}`}
              onClick={() => this.setTab(TABS.PACKAGES)}
            >
              <p>Paquetes</p>
            </button>
          </div>
        </div>

        {tab == TABS.MEMBERSHIPS && (
          <>
            <Modal
              className='modal-create-membership'
              visible={visible}
              title={`${this.state.item ? 'Editar' : 'Nueva'} membresía`}
              onClose={() => this.onClose()}
            >
              <ModalCreate
                colors={this.state.colors}
                item={this.state.item}
                onClose={() => this.onClose()}
              />
            </Modal>

            <div className='row row-filter'>
              <div className='col-md-8'>
                <div className='row'>
                  <div className='col-md-6'>
                    <Select
                      color='white'
                      placeholder='Seleccionar'
                      label='Usuario'
                      name='level_id'
                      onChange={(e: any) =>
                        this.change(e, async () => {
                          this.load(true);
                        })
                      }
                      value={this.state.form.level_id}
                      options={this.state.levels.map((item: any) => {
                        return {
                          value: item.id,
                          label: item.name,
                        };
                      })}
                    />
                  </div>
                  <div className='col-md-1'>
                    {this.state.form != INITIAL_STATE && (
                      <button className='btn btn-clean' onClick={() => this.reset()}>
                        <img src={CleanIcon} />
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className='col-md-4 text-right'>
                {checkPermission(Constants.MODULES.MEMBERSHIPS, 'write') && (
                  <div className='container-add-table' onClick={() => this.add()}>
                    <p>Nuevo</p>
                    <button className='btn add-btn-table'>
                      <img src={AddIcon} />
                    </button>
                  </div>
                )}
              </div>
            </div>

            {(!this.state.form.level_id ||
              parseInt(this.state.form.level_id) == Constants.LEVELS.CLIENT) && (
              <div className='level-container'>
                <div className='header-level'>
                  <img src={UserMembershipIcon} />
                  <p>Usuario Cliente</p>
                </div>

                <div className='row'>
                  {this.state.data
                    .filter((i: any) => i.level_id == Constants.LEVELS.CLIENT)
                    .map((item: any) => {
                      return (
                        <div className='col-md-4'>
                          <div className='item-membership'>
                            <div
                              className='container-color'
                              style={{
                                backgroundColor: item?.color?.color || undefined,
                              }}
                            >
                              <img
                                className='image-principal'
                                src={Constants.BASE_STORAGE + item.image}
                              />
                              <div className='container-name'>
                                <p className='name'>{item.name}</p>
                                <div className='container-prices'>
                                  {!!item.month && (
                                    <div className='item-price'>
                                      <p className='price-title'>Mensual</p>
                                      <p className='price'>
                                        {Globals.formatMiles(item.price_month)}
                                      </p>
                                    </div>
                                  )}
                                  {!!item.year && (
                                    <div className='item-price'>
                                      <p className='price-title'>Anual</p>
                                      <p className='price'>
                                        {Globals.formatMiles(item.price_year)}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className='footer-membership'>
                              {checkPermission(Constants.MODULES.MEMBERSHIPS, 'write') && (
                                <Tooltip title='Editar'>
                                  <a
                                    className='link-icon'
                                    href='#'
                                    onClick={(e: any) => this.edit(e, item)}
                                  >
                                    <img src={EditIcon} />
                                  </a>
                                </Tooltip>
                              )}
                              {checkPermission(Constants.MODULES.MEMBERSHIPS, 'delete') && (
                                <Tooltip title='Eliminar'>
                                  <a
                                    className='link-icon'
                                    href='#'
                                    onClick={(e: any) => this.delete(e, item)}
                                  >
                                    <img src={TrashIcon} />
                                  </a>
                                </Tooltip>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>

                {this.state.data.filter((i: any) => i.level_id == Constants.LEVELS.CLIENT).length ==
                  0 && <p className='no-items'>No se encontraron membresías</p>}
              </div>
            )}

            {(!this.state.form.level_id ||
              parseInt(this.state.form.level_id) == Constants.LEVELS.LAWYER) && (
              <div className='level-container'>
                <div className='header-level'>
                  <img src={LawyerMembershipIcon} />
                  <p>Usuario Abogado</p>
                </div>

                <div className='row'>
                  {this.state.data
                    .filter((i: any) => i.level_id == Constants.LEVELS.LAWYER)
                    .map((item: any) => {
                      return (
                        <div className='col-md-4'>
                          <div className='item-membership'>
                            <div
                              className='container-color'
                              style={{
                                backgroundColor: item?.color?.color || undefined,
                              }}
                            >
                              <img
                                className='image-principal'
                                src={Constants.BASE_STORAGE + item.image}
                              />
                              <div className='container-name'>
                                <p className='name'>{item.name}</p>
                                <div className='container-prices'>
                                  {!!item.month && (
                                    <div className='item-price'>
                                      <p className='price-title'>Mensual</p>
                                      <p className='price'>
                                        {Globals.formatMiles(item.price_month)}
                                      </p>
                                    </div>
                                  )}
                                  {!!item.year && (
                                    <div className='item-price'>
                                      <p className='price-title'>Anual</p>
                                      <p className='price'>
                                        {Globals.formatMiles(item.price_year)}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className='footer-membership'>
                              {checkPermission(Constants.MODULES.MEMBERSHIPS, 'write') && (
                                <Tooltip title='Editar'>
                                  <a
                                    className='link-icon'
                                    href='#'
                                    onClick={(e: any) => this.edit(e, item)}
                                  >
                                    <img src={EditIcon} />
                                  </a>
                                </Tooltip>
                              )}
                              {checkPermission(Constants.MODULES.MEMBERSHIPS, 'delete') && (
                                <Tooltip title='Eliminar'>
                                  <a
                                    className='link-icon'
                                    href='#'
                                    onClick={(e: any) => this.delete(e, item)}
                                  >
                                    <img src={TrashIcon} />
                                  </a>
                                </Tooltip>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>

                {this.state.data.filter((i: any) => i.level_id == Constants.LEVELS.LAWYER).length ==
                  0 && <p className='no-items'>No se encontraron membresías</p>}
              </div>
            )}
          </>
        )}

        {tab == TABS.PACKAGES && <AdminPackages />}
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(AdminMemberships);
